import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { Home } from './Home';
import Maintenance from "./Maintenance"
import MaintenanceMessage from './MaintenanceMessage'

class Main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            authorities: '',
            isLuxTrust: '',
            loginPage: '',
            isMaintenance: '0',
            maintenancePlanned: '0',
        }
    }

    componentDidMount() {
        fetch('config/getConfig?name=maintenance', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        }).then(response => {
            return response.json()
        }).then(data => {
            this.setState({
                isMaintenance: data.value
            })
            fetch('config/getConfig?name=maintenancePlanned', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            })
                .then(response => {
                    return response.json()
                }).then(data => {
                    this.setState({
                        maintenancePlanned: data.value
                    })
                    fetch('clientdetails/authorities?clientid=SampleClientId', {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                        }
                    }).then(response => {
                        return response.json();
                    }).then(data => {
                        this.setState({
                            authorities: data.authorities
                        })
                        if (this.state.authorities === "ROLE_TWO_FACTOR_AUTHENTICATION_ENABLED") {
                            fetch('config/returnEnvironment?name=LuxtrustEnvironment', {
                                method: 'POST',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json',
                                }
                            }).then(response => {
                                return response.json();
                            }).then(data => {
                                this.setState({
                                    isLuxTrust: data.value
                                })
                            })
                        } else {
                            fetch('config/returnSSOPage?name=LoginSSOPage', {
                                method: 'POST',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json',
                                }
                            }).then(response => {
                                return response.json();
                            }).then(data => {
                                this.setState({
                                    loginPage: data.value
                                })
                            })
                        }
                    });
                })
        })
    }

    render() {
        const isMaintenance = this.state.isMaintenance
        const isMaintenancePlanned = this.state.maintenancePlanned
        return (
            <div>
                {
                    isMaintenance === '1' ? (
                        <div>
                            <Maintenance />
                        </div>)
                        : (
                            <div>
                                <main>
                                    <Switch>
                                        <Route exact path="/" render={(props) => <Home {...props} authorities={this.state.authorities} isLuxTrust={this.state.isLuxTrust} loginPage={this.state.loginPage} />} />
                                    </Switch>
                                    
                                </main>

                                {isMaintenancePlanned === '1'?<MaintenanceMessage maintenancePlanned={this.state.maintenancePlanned} /> : null}
                                
                               
                            </div>
                        )
                }
                
            </div>
        )
    }
}
export default Main


// WEBPACK FOOTER //
// ./src/main/resources/js/components/Main.js